import * as React from "react";

import {
  ThreeDPanelState,
  usePanelState,
  useVizDispatch,
} from "@/shared/state/visualization";
import { setThreeDPanelConfig } from "@/shared/state/visualization/actions";
import { Grid } from "@/shared/state/visualization/schema/v1/three-d";

import { GridFields } from "./GridFields";

interface GridSettingsProps {
  panelId: string;
}

/**
 * The panel's grid editor: {@link GridFields} wired to the visualization store.
 *
 * Everything about *editing* a grid is in `GridFields`; what is here is the
 * store binding — which panel's grid, what its unset fields default to, and how
 * an edit is dispatched.
 */
export function GridSettings({ panelId }: GridSettingsProps) {
  const dispatch = useVizDispatch();
  const panelState = usePanelState(panelId) as ThreeDPanelState;
  const grid: Grid = React.useMemo(
    () => ({
      // Default values
      color: "#888888",
      scale: 1,
      verticalOffset: undefined,
      // Config values,
      ...panelState.config?.grid,
    }),
    [panelState.config?.grid],
  );

  const onChange = React.useCallback(
    (updatedGrid: Grid) => {
      dispatch(setThreeDPanelConfig(panelId, { grid: updatedGrid }));
    },
    [dispatch, panelId],
  );

  return <GridFields value={grid} onChange={onChange} />;
}
